<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card v-if="signinOk" class="elevation-12">
          <v-toolbar dark color="primary">
            <v-toolbar-title>Registro</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            El cambio o registro de contraseña para el usuario <strong>{{ email }}</strong> se ha efectuado correctamente 
          </v-card-text>
          <v-card-actions>            
            <v-spacer></v-spacer>
            <v-btn color="primary" @click="goHome">Continuar</v-btn>
          </v-card-actions>
        </v-card>

      </v-flex>
    </v-layout>
  </v-container>    
</template>

<style>

</style>

<script>
import { SIGNIN_REQUEST } from '../store/actions/auth'
import { mapGetters } from 'vuex'

export default {
  name: 'SigninRequest', 
  props: {
    'token': { type: String, required: true }
  },
  data () {
    return {
      error: '',
      signinOk: false,
      email: ''
    }
  },
  computed: {
    ...mapGetters(['authStatus'])
  },
  created: function () {
    this.signin()
  },
  methods: {
    signin: function () {
      this.$store.dispatch(SIGNIN_REQUEST, { token: this.token })
      .then((response) => {
        this.email = response.EMAIL.toLowerCase()
        this.signinOk = true
      })
      .catch(error => {
        this.signinOk = false
        this.error = error
      })
    },
    goHome: function() {
      this.$router.push('/')
    }
  }
}
</script>


